import { Pipe, PipeTransform } from '@angular/core';
import { FileService } from '../shared/files/file.service';

@Pipe({
  name: 'fromStorage'
})
export class FromStoragePipe implements PipeTransform {
  constructor(
    private fileService: FileService,
  ) { }

  transform(value: any, ...args: any[]): any {
    const path = value.split('/');
    const dir = path.slice(0, -1).join('/');
    const file = path.slice(-1).join('');

    return this.fileService.getURLDocument(`${dir}/${file}`).toPromise().then(result => result);
  }

}
